import { render, staticRenderFns } from "./attributeName.vue?vue&type=template&id=e860d35c&scoped=true&"
import script from "./attributeName.vue?vue&type=script&lang=js&"
export * from "./attributeName.vue?vue&type=script&lang=js&"
import style0 from "./attributeName.vue?vue&type=style&index=0&id=e860d35c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e860d35c",
  null
  
)

export default component.exports